import Vuex from 'vuex'

export const store = new Vuex.Store({

  state: {
    maintenance:false,
    news:{
      title:'',
      content:''
    },
    post:{
      title:"empty",
      content:"empty",
      comments:[],
      author:"empty"
    },
    user: {
      loggedIn: false,
      data: null,
      isadmin:false,
    },
    mapData: {
      clinic: "-",
      doctor: "-",
      specialization: "-",
      schedule: "-",
      address: "-",
      phone: "-"
    },
    rows_obj: {},
    columns: [
      {
        name: "name",
        required: true,
        label: "Title",
        align: "center",
        field: (row) => row.name,
        format: (val) => `${val}`,
        sortable: true,
      },
      {
        name: "author",
        align: "center",
        label: "Author",
        field: "author",
        sortable: true,
      },
      {
        name: "specialty",
        label: "Specialty",
        field: "specialty",
        sortable: true,
        align: "center",
      },
      {
        name: "date",
        label: "Date",
        field: "date",
        sortable: true,
        align: "center",
      },
      {
        name: "delete",
        label: "Delete",
        field: "",
        sortable: false,
        align: "center",
      },
    ],
  },
  getters: {
    user: state => {
      return state.user
    }
  },
  mutations: {
    UPDATE_ADMIN(state,payload){
      state.user.isadmin = payload.status
    },
    UPDATE_NEWS(state,payload){
      state.news.title = payload.title,
      state.news.content = payload.content
    },
    UPDATE_POST_COMMENTS(state,payload){
      state.post.comments = payload.comments
    },
    UPDATE_POST_DATA(state,payload){
      state.post.title = payload.title,
      state.post.content = payload.content,
      state.post.comments = payload.comments,
      state.post.author = payload.author
    },
    UPDATE_CARD_INFO(state, payload) {
      state.mapData.clinic = payload.clinic,
        state.mapData.doctor = payload.doctor,
        state.mapData.specialization = payload.specialization,
        state.mapData.schedule = payload.schedule,
        state.mapData.address = payload.address,
        state.mapData.phone = payload.phone
    },
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data.data;
    },
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});

